export default "__VITE_ASSET__PvtxEQFK__"